export default "__VITE_ASSET__DbDbXSVl__"